<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Detalhes da Categoria</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <div class="mb-3" v-if="!loading">
                <button class="btn btn-outline-primary mr-3"
                    @click="gotoModification(category)">
                    Editar
                </button>

                <button class="btn btn-outline-secondary mr-3"
                    @click="forceChannelsSync(category)"
                    :disabled="forcingChannelSync">
                    Forçar sincronização

                    <Loading v-show="forcingChannelSync" />
                </button>

                <a class="btn btn-outline-secondary"
                    :href="getAuditUrl(category.id, EntityEnum.Category)" target="_blank">
                    Ir para auditoria
                    <fa icon="external-link-alt" class="muven-external-link ml-1" />
                </a>
            </div>

            <Loading page v-if="loading" />            

            <div v-if="!loading">
                <div class="muven-column-layout">
                    <div class="muven-column-left">
                        <div class="muven-card mb-3">
                            <div class="muven-card-title">
                                <p>{{category.name}}</p>
                            </div>

                            <div class="row">
                                <div class="col-12 mb-3">
                                    <label>Título</label>
                                    <p>{{category.title | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12 mb-3">
                                    <label>Descrição</label>
                                    <p>{{category.description | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12 mb-3">
                                    <label>Categoria Pai</label>
                                    <p>{{category.getParentName() | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12 mb-3">
                                    <label>Palavras chave</label>
                                    <p>{{category.keywords | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12">
                                    <label>Status</label>
                                    <p>
                                        <span v-if="category.isActive">Ativa</span>
                                        <span v-if="!category.isActive">Inativa</span>
                                    </p>
                                </div>
                            </div>
                        </div>                        
                    </div>            

                    <div class="muven-column-right">
                        <div class="muven-card mb-3">
                            <div class="muven-card-title">
                                <p>Integração</p>
                            </div>

                            <div>
                                <div>
                                    <label>Id retaguarda</label>
                                    <p>{{category.idSource | infoOrPlaceholder}}</p>
                                </div>                          

                                <div class="mt-3" v-for="(categoryChannel, index) in category.channels" :key="index"> 
                                    <label>Id {{categoryChannel.channel.name}}</label>
                                    <p>{{categoryChannel.idExternalChannel | infoOrPlaceholder}}</p>
                                </div>
                            </div>
                        </div>
                    </div>                     
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import categoryService from '@/category/services/CategoryService'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { CategoryModel } from '@/category/models/CategoryModel'
import { EntityEnum } from '@c2b/muven-commons'
import GetAuditUrl from '@/utils/mixins/GetAuditUrl'

export default {
    name: 'CategoryView',
    data() {
        return {
            EntityEnum,
            loading: true,
            forcingChannelSync: false,
            category: new CategoryModel(),
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Categorias',
                    path: '/categorias',
                },
                {
                    id: 1,
                    description: `Detalhes de #${this.$route.params.id}`,
                    path: '',
                },
            ],    
        }
    },
    mixins: [
        GetAuditUrl,
    ],
    filters: {
        infoOrPlaceholder,
    },
    async mounted() {
        try {
            this.category = await categoryService.getCategoryById(this.$route.params.id)
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async allowExportModifiedInCategory(allowExport) {
            try {
                    await categoryService.updateAllowExportInCategory(this.category.id, allowExport)
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }
        },
        gotoModification(cat) {
            this.$router.push(`/categorias/${cat.id}/edicao`)
        },
        async forceChannelsSync(cat) {
            this.forcingChannelSync = true

            try {
                await categoryService.forceChannelsSync(cat.id)
                this.$floatingAlert.info({
                    message: `Solicitação de sincronização da categoria <b>${cat.name}</b> registrado com sucesso.`,
                    timeVisible: 10000,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message || `Houve um problema no momento de forçar a sincronização da categoria <b>${cat.name}</b>. Tente novamente mais tarde.`  
                })
            }

            this.forcingChannelSync = false
        },
    },
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
    },
}
</script>

